import { fg } from '@atlaskit/platform-feature-flags/fg';

export const POPUP_SIZED_EXTERNAL_NAV_APP_IDS: ReadonlySet<string> = new Set([
	'11995cbf-629c-4d90-890c-7fdd0ed69c49',
]);

export function navigate(
	url: string,
	type: 'same-tab' | 'new-tab',
	push?: (path: string) => void,
	appId?: string,
): void {
	switch (type) {
		case 'new-tab': {
			const usePopupSizedWindow =
				!!appId &&
				POPUP_SIZED_EXTERNAL_NAV_APP_IDS.has(appId) &&
				fg('store_forge_configure_renderer');

			window.open(
				url,
				'_blank',
				usePopupSizedWindow
					? 'popup,width=480,height=720,noopener,noreferrer'
					: 'noopener noreferrer',
			);
			break;
		}
		case 'same-tab':
			if (push) {
				push(url);
			} else {
				window.location.href = url;
			}
			break;
	}
}
